var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83268 13.8334L14.7077 7.95841L13.541 6.79175L8.83268 11.5001L6.45768 9.12508L5.29102 10.2917L8.83268 13.8334ZM9.99935 18.3334C8.84657 18.3334 7.76324 18.1147 6.74935 17.6772C5.73546 17.2397 4.85352 16.6459 4.10352 15.8959C3.35352 15.1459 2.75977 14.264 2.32227 13.2501C1.88477 12.2362 1.66602 11.1529 1.66602 10.0001C1.66602 8.8473 1.88477 7.76397 2.32227 6.75008C2.75977 5.73619 3.35352 4.85425 4.10352 4.10425C4.85352 3.35425 5.73546 2.7605 6.74935 2.323C7.76324 1.8855 8.84657 1.66675 9.99935 1.66675C11.1521 1.66675 12.2355 1.8855 13.2493 2.323C14.2632 2.7605 15.1452 3.35425 15.8952 4.10425C16.6452 4.85425 17.2389 5.73619 17.6764 6.75008C18.1139 7.76397 18.3327 8.8473 18.3327 10.0001C18.3327 11.1529 18.1139 12.2362 17.6764 13.2501C17.2389 14.264 16.6452 15.1459 15.8952 15.8959C15.1452 16.6459 14.2632 17.2397 13.2493 17.6772C12.2355 18.1147 11.1521 18.3334 9.99935 18.3334Z",
    fill: "#49C568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check_circle_green.f1cb2674e34bee0317c6a1444d9ebf3b.svg";
export { ForwardRef as ReactComponent };